/**
 * Call It In Dashboard - AppBar Component
 * Description: Custom top navigation bar for internal courier dashboard.
 * Author: Shaun Matthews
 * Company: Call It In LLC
 * Date: 2025
 * 
 * This file is part of the proprietary Call It In software suite.
 * All rights reserved. Unauthorized use or distribution is strictly prohibited.
 */

import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";
import boxShadows from "assets/theme-dark/base/boxShadows";

import rgba from "assets/theme-dark/functions/rgba";

const { background, grey } = colors;
const { borderWidth, borderRadius } = borders;
const { xs } = boxShadows;

const card = {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: 0,
      wordWrap: "break-word",
      backgroundImage: "none",
      backgroundColor: background.card,
      backgroundClip: "border-box",
      border: `${borderWidth[1]} solid ${grey[800]}`,
      borderRadius: borderRadius.lg,
      boxShadow: xs,
      overflow: "visible",
    },
  },
};

export default card;
